import React from "react";
import { ExternalLink, X } from "react-feather";
import {
  KG_INSPECTOR_ICON_DEFAULT_SIZE,
  kgInspectorIcons,
} from "../../kg/canvas/inspector/kgInspectorIcons";
import {
  CloseButton,
  ExternalLinkButton,
  HeaderMain,
  HeaderRoot,
  LeadingIconSlot,
  Logo,
  LogoTitleGroup,
  Subtitle,
  Title,
  TitleRow,
} from "./KgNodePanelHeader.styles";
import type { KgNodePanelHeaderProps } from "./KgNodePanelHeader.types";

export const KgNodePanelHeader: React.FC<KgNodePanelHeaderProps> = ({
  headerIcon,
  logoUrl,
  title,
  subtitle,
  externalUrl,
  onClose,
}) => {
  const HeaderIconComponent = headerIcon
    ? kgInspectorIcons[headerIcon]
    : null;
  const headerIconSize = headerIcon
    ? KG_INSPECTOR_ICON_DEFAULT_SIZE[headerIcon]
    : 14;

  return (
  <HeaderRoot>
    <HeaderMain>
      <TitleRow>
        <LogoTitleGroup>
          {HeaderIconComponent && (
            <LeadingIconSlot>
              <HeaderIconComponent size={headerIconSize} />
            </LeadingIconSlot>
          )}
          {logoUrl && <Logo src={logoUrl} alt="" />}
          <Title>{title}</Title>
        </LogoTitleGroup>
        {externalUrl && (
          <ExternalLinkButton
            href={externalUrl}
            target="_blank"
            rel="noreferrer"
            aria-label={`Open ${title} in a new tab`}
          >
            <ExternalLink size={14} />
          </ExternalLinkButton>
        )}
      </TitleRow>
      <Subtitle>{subtitle}</Subtitle>
    </HeaderMain>
    <CloseButton
      onClick={onClose}
      aria-label="Close panel"
      type="button"
    >
      <X size={16} />
    </CloseButton>
  </HeaderRoot>
  );
};

export default KgNodePanelHeader;
